import { action } from 'typesafe-actions';
import { EmailsActionTypes, OutboundEmailsResponse } from 'types';

export const listReferralsEmailsStart = (payload: any) =>
  action(EmailsActionTypes.LIST_REFERRALS_EMAILS_START, payload);
export const listReferralsEmailsSuccess = (payload: OutboundEmailsResponse) =>
  action(EmailsActionTypes.LIST_REFERRALS_EMAILS_SUCCESS, payload);
export const listReferralsEmailsFailure = (payload: any) =>
  action(EmailsActionTypes.LIST_REFERRALS_EMAILS_FAILURE, payload);

export const listResponsesEmailsStart = (payload: any) =>
  action(EmailsActionTypes.LIST_RESPONSES_EMAILS_START, payload);
export const listResponsesEmailsSuccess = (payload: OutboundEmailsResponse) =>
  action(EmailsActionTypes.LIST_RESPONSES_EMAILS_SUCCESS, payload);
export const listResponsesEmailsFailure = (payload: any) =>
  action(EmailsActionTypes.LIST_RESPONSES_EMAILS_FAILURE, payload);

export const getReferralEmailDetailStart = (payload: any) =>
  action(EmailsActionTypes.GET_REFERRAL_EMAIL_DETAIL_START, payload);
export const getReferralEmailDetailSuccess = (payload: any) =>
  action(EmailsActionTypes.GET_REFERRAL_EMAIL_DETAIL_SUCCESS, payload);
export const getReferralEmailDetailFailure = (payload: any) =>
  action(EmailsActionTypes.GET_REFERRAL_EMAIL_DETAIL_FAILURE, payload);

export const getResponsesEmailDetailStart = (payload: any) =>
  action(EmailsActionTypes.GET_RESPONSE_EMAIL_DETAIL_START, payload);
export const getResponsesEmailDetailSuccess = (payload: any) =>
  action(EmailsActionTypes.GET_RESPONSE_EMAIL_DETAIL_SUCCESS, payload);
export const getResponsesEmailDetailFailure = (payload: any) =>
  action(EmailsActionTypes.GET_RESPONSE_EMAIL_DETAIL_FAILURE, payload);

export const previewEmailStart = (payload: any) =>
  action(EmailsActionTypes.PREVIEW_EMAIL_START, payload);
export const previewEmailSuccess = (payload: any) =>
  action(EmailsActionTypes.PREVIEW_EMAIL_SUCCESS, payload);
export const previewEmailFailure = (payload: any) =>
  action(EmailsActionTypes.PREVIEW_EMAIL_FAILURE, payload);
export const previewResponseStart = (payload: any) =>
  action(EmailsActionTypes.PREVIEW_RESPONSE_START, payload);

export const resendEmailStart = (payload: any) =>
  action(EmailsActionTypes.RESEND_EMAIL_START, payload);
export const resendEmailSuccess = (payload: any) =>
  action(EmailsActionTypes.RESEND_EMAIL_SUCCESS, payload);
export const resendEmailFailure = (payload: any) =>
  action(EmailsActionTypes.RESEND_EMAIL_FAILURE, payload);

export const resendToOtherEmailStart = (payload: any) =>
  action(EmailsActionTypes.RESEND_TO_OTHER_EMAIL_START, payload);
export const resendToOtherEmailSuccess = (payload: any) =>
  action(EmailsActionTypes.RESEND_TO_OTHER_EMAIL_SUCCESS, payload);
export const resendToOtherEmailFailure = (payload: any) =>
  action(EmailsActionTypes.RESEND_TO_OTHER_EMAIL_FAILURE, payload);

export const downloadEmailBodyStart = (payload: any) =>
  action(EmailsActionTypes.DOWNLOAD_EMAIL_BODY_START, payload);
export const downloadEmailBodySuccess = (payload: any) =>
  action(EmailsActionTypes.DOWNLOAD_EMAIL_BODY_SUCCESS, payload);
export const downloadEmailBodyFailure = (payload: any) =>
  action(EmailsActionTypes.DOWNLOAD_EMAIL_BODY_FAILURE, payload);

export const setEmailFilter = (payload: any) =>
  action(EmailsActionTypes.SET_EMAIL_SEARCH_FILTER, payload);

export const clearAllEmails = () => action(EmailsActionTypes.CLEAR_EMAILS);

export const clearEmailBodyDownload = () =>
  action(EmailsActionTypes.CLEAR_EMAIL_BODY_DOWNLOAD);
